import { useEffect, useState } from 'react';
import { Column, GridApi } from 'ag-grid-community';
import { Button, Drawer } from 'antd';
import { observer } from 'mobx-react-lite';

import {
  TEntityGridExtraFilter,
  TEntityGridFilter,
} from 'app/common/entity-grid/core';

import { BaseFilterModel } from '../filters/create-data-grid-filter';
import { useDataGridApi } from '../index';
import { FiltersButton } from './filters-button';
import { FiltersCollapse } from './filters-collapse';

type FiltersSettingsProps = {
  extraFilters?: TEntityGridExtraFilter[];
  filterModels?: TEntityGridFilter | null;
  onExtraFilterChange?: (model: BaseFilterModel<unknown, string>) => void;
  onResetAll?: () => void;
};

export const FiltersSettings = observer(
  ({
    extraFilters,
    filterModels,
    onExtraFilterChange,
    onResetAll,
  }: FiltersSettingsProps) => {
    const [openDrawer, setOpenDrawer] = useState(false);
    const dataGridApi = useDataGridApi();
    const [columns, setColumns] = useState<Column[]>([]);
    const [gridApi, setGridApi] = useState<GridApi | null>(null);

    const handleResetAll = () => {
      gridApi?.setFilterModel(null);
      gridApi?.deselectAll();
      onResetAll?.();
    };

    useEffect(() => {
      async function getUserProvidedFilterComponents() {
        const api = await dataGridApi();
        setGridApi(api);

        const cols = api.getColumns();
        if (!cols) return;

        // looking for columns with user provided filters
        const colFilters = cols.reduce<Column[]>((acc, col) => {
          const userColDef = col.getUserProvidedColDef();
          const hasDataGridFilter =
            userColDef &&
            typeof userColDef.filter === 'function' &&
            'filterName' in userColDef.filter;

          if (hasDataGridFilter) {
            acc.push(col);
          }

          return acc;
        }, []);

        setColumns(colFilters);
      }

      getUserProvidedFilterComponents();
    }, [dataGridApi]);

    return (
      <>
        <FiltersButton
          gridApi={gridApi}
          onShowFilters={() => setOpenDrawer(true)}
          onResetAll={handleResetAll}
          style={{ marginRight: 8 }}
        />
        <Drawer
          mask={false}
          width={400}
          title="Настройка фильтров"
          open={openDrawer}
          onClose={() => setOpenDrawer(false)}
          footer={
            <Button block onClick={handleResetAll}>
              Сбросить все
            </Button>
          }
        >
          <FiltersCollapse
            columns={columns}
            extraFilters={extraFilters}
            filterModels={filterModels}
            gridApi={gridApi}
            onExtraFilterChange={onExtraFilterChange}
          />
        </Drawer>
      </>
    );
  },
);
